import { useCallback, useMemo } from 'react';
import find from 'lodash/find';

import CreateClientContactModal from '@/modules/clients/components/CreateClientContactModal';
import { CreateClientContactFormValueType } from '@/modules/clients/components/CreateClientContactModal/types';
import { ClientFragment } from '@/modules/clients/graphql/fragments/generated/client';
import { ClientContactFragment } from '@/modules/clients/graphql/fragments/generated/clientContact';
import useClientContactActions from '@/modules/clients/hooks/useClientContactActions';

import { DialogProps } from '../types';

function AddClientContact({ onClose, client, clientContactId }: DialogProps) {
  const contact = useMemo(
    () => find(client?.contacts as ClientContactFragment[], { _id: clientContactId }),
    [client?.contacts, clientContactId],
  );

  const { addContact, editContact } = useClientContactActions({
    clientId: (client as ClientFragment).id,
  });

  const onSubmit = useCallback(
    async (contactValues: CreateClientContactFormValueType) => {
      if (clientContactId) {
        await editContact(clientContactId, contactValues);
      } else {
        addContact(contactValues);
      }
    },
    [addContact, clientContactId, editContact],
  );

  return (
    <CreateClientContactModal
      initialFormValues={contact}
      isEditing={Boolean(clientContactId)}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
}

export default AddClientContact;
